// @ts-nocheck
import { FEATURE_REQUEST_FEEDBACK_ERROR, FEATURE_REQUEST_FEEDBACK_LOADING, FEATURE_REQUEST_FEEDBACK_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const FeatureRequestFeedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case FEATURE_REQUEST_FEEDBACK_LOADING:
            return Object.assign({}, state, { loading: true })
        case FEATURE_REQUEST_FEEDBACK_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case FEATURE_REQUEST_FEEDBACK_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

